<template lang="pug">
  include /mixins
  +b.g-row.--align_center
    +b.g-cell.g-cols.phone-input--code
      +b.d-control-input--appearance_bordered.D-CONTROL-MULTISELECT(
        :options='list || []',
        v-model='code',
        :label-component='$options.staticInput'
        name='code',
        :allow-empty="false"
        :input-label="_('Ваш номер телефону')",
        :disabled='disabled'
        @input='setCode(); save()'
        :custom-label='obj => obj.props.code'
      )
        template(#option="{ option }")

          +b.switcher-with-dropdown
            +e.current--dark
              +e.img-wrap
                +e.img.IMG(
                  :src='option.props.icon'
                  loading='lazy'
                )
              +e.link--dark.ds-caption--size_md.--appearance_uppercase.SPAN {{ option.props.code }}
        template(#singleLabel="{ option }")
          +b.switcher-with-dropdown
            +e.current--dark
              +e.img-wrap
                +e.img.IMG(
                  :src='option.props.icon'
                  loading='lazy'
                )
              //- +e.link--dark.ds-caption--size_xs.--appearance_uppercase.SPAN {{ option.props.code }}
    +b.g-cell.g-cols.phone-input--phone
      +b.d-control-input--appearance_bordered.D-CONTROL-INPUT(
        :rules="{required: true, phone: { codeLength: code && code.props && code.props.code.length - 1, numberAfterCode: code && code.props && code.props.number_after_code }, forbidden_phone_codes: forbidden_phone_codes }",
        @input='normalizePhone(); checkCode(); save()'
        v-model='phone',
        name='phone'
        v-bind='props'
        :disabled='disabled'
        type='tel'
      )
</template>

<script>

import StaticLabel from '@app/UiElements/Controls/StaticLabel'

import {
  mapState, mapActions,
} from 'vuex'

import {
  phoneCodeListResource,
} from '@api/vendor.service'

import {
  getCookie,
} from '@utils/cookies'

import {
  COUNTRY_CODE_COOKIE_NAME,
} from '@app/consts'

export default {
  name: 'PhoneInput',
  phoneCodeListResource,
  staticInput: StaticLabel,
  props: {
    props: {
      type: Object,
      default: () => {},
    },
    value: {},
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      phone: '',
      code: '',
      default_code: getCookie(COUNTRY_CODE_COOKIE_NAME),
      forbidden_phone_codes: (window.forbidden_phone_codes || '').split('|'),
      list: [],
      regexp: [],
    }
  },
  created() {
    this.getCodes()
  },
  computed: {
    ...mapState('country', ['phoneCodes']),
    code_is_forbidden() {
      if (!this.phone) return false
      return (this.forbidden_phone_codes || []).some(e => this.phone.startsWith(e))
    },
  },
  watch: {
    value: {
      async handler() {
        if (!this.list.length) await this.getCodes()
        this.phone = (this.value || '')
          .replace(/[^\d+]/g, '')
          .replace(/(?!^)\+/g, '')
        if (!this.phone) this.setCode()
        this.checkCode()
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('country', ['getPhoneCodes']),
    async getCodes() {
      if (!this.phoneCodes.length) {
        await this.getPhoneCodes()
      }
      // const { data } = (await phoneCodeListResource.execute())
      this.list = this.phoneCodes
      if (!this.code) {
        this.code = this.list
          .find(c => c.props.countries
            .find(e => e.props.iso_code === this.default_code))
      }
      this.list.forEach(l => {
        const t = l.props.code.replace('+', '[\+]')
        if (Array.isArray(l.props.prefix_array) && l.props.prefix_array.length) {
          l.props.regexp = l.props.prefix_array.map(prefix => new RegExp(`^${t}${prefix}`, 'i'))
        } else {
          // Для кодів без prefix_array теж робимо масив, але з одним елементом
          l.props.regexp = [new RegExp(`^${t}`, 'i')]
        }
      })
    },
    save() {
      this.$emit('input', this.phone)
    },
    setCode() {
      if (!this.code) return
      this.phone = `${this.code.props.code}`
    },
    checkCode() {
      const code = this.list.find(r => {
        if (!Array.isArray(r.props.regexp)) return false
        return r.props.regexp.some(re => re.test(this.phone))
      })

      if (code) {
        this.code = code
      }
    },
    normalizePhone() {
      if (typeof this.phone !== 'string') return
      this.phone = this.phone
        .replace(/[^\d+]/g, '')
        .replace(/(?!^)\+/g, '')
    },
  },

}
</script>
